import { useEffect, useState } from "react";

const ScrollToTopButton = ({ className = "", showAt = 200, icon = "↑" }) => {
  const [visible, setVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > showAt);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [showAt]);

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed sm:bottom-6 bottom-16 right-6
        w-8 h-8
        bg-red-600 text-white
        rounded-full
        shadow-lg
        hover:bg-red-700
        transition
        flex items-center justify-center
        ${className}
      `}
    >
      {icon}
    </button>
  );
};

export default ScrollToTopButton;
